module.exports = __webpack_public_path__ + "img/ic-waist-outline.e118a751.svg";